/** Shared skill types — mirrors SkillPublicDTO from Athena skills package. */
export type SkillCard = {
  id: string
  title: string
  description: string
  icon: string
  /** Short user-visible label when invoking (same as title). */
  starter_message: string
  requires_business_type?: boolean
}

/** Offline fallback — mirrors backend catalog order; live list from GET /chat/skills */
export const FALLBACK_SKILLS: SkillCard[] = [
  {
    id: 'role_clarity',
    title: 'Role Clarity',
    description: 'Define role, KRAs, tasks, and metrics for any position',
    icon: '',
    starter_message: 'Role Clarity',
  },
  {
    id: 'elevator_pitch',
    title: 'Elevator Pitch',
    description: 'Craft a ≤30 second Left Brain + Right Brain elevator pitch',
    icon: '',
    starter_message: 'Elevator Pitch',
  },
  {
    id: 'customer_profile',
    title: 'Customer Profile',
    description: 'Build demographic and psychographic customer profiles',
    icon: '',
    starter_message: 'Customer Profile',
  },
  {
    id: 'product_funnel',
    title: 'Product Funnel',
    description: 'Map easy-to-buy, primary, and high-value offerings',
    icon: '',
    starter_message: 'Product Funnel',
  },
  {
    id: 'customer_ndp',
    title: 'Customer NDP',
    description: 'List Needs, Desires, and Problems per segment',
    icon: '',
    starter_message: 'Customer NDP',
  },
  {
    id: 'sim',
    title: 'Sales Interaction Map',
    description: '8-step sales journey from Awareness to Retention',
    icon: '',
    starter_message: 'Sales Interaction Map',
    requires_business_type: true,
  },
  {
    id: 'pss',
    title: 'Process Structure System',
    description: 'Structure processes for how your business runs',
    icon: '',
    starter_message: 'Process Structure System',
    requires_business_type: true,
  },
]

export const formatSkillLabel = (skillId: string) => skillId.replace(/_/g, ' ')
